/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login5Inputs */

const en_login5 = /** @type {(inputs: Login5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login`)
};

const de_login5 = /** @type {(inputs: Login5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

/**
* | output |
* | --- |
* | "Login" |
*
* @param {Login5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const login5 = /** @type {((inputs?: Login5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login5(inputs)
	return en_login5(inputs)
});
export { login5 as "LOGIN" }